import createOrUpdateHiddenField from './createOrUpdateHiddenField';
import getKeysForExtraInfo from './getKeysForExtraInfo';
import { DEFAULT_AD_PARAMS } from './defaultAdParams';

/**
 *
 * @param {Object} win
 * @param {HTMLFormElement} form
 * @param {Object} prefParams
 */
const injectExtraInfo = (
	win,
	form,
	{ cookiesForExtraInfo = '', paramsForExtraInfo = '' } = {}
) => {
	const cookieNames = getKeysForExtraInfo(win, cookiesForExtraInfo);
	const paramNames = getKeysForExtraInfo(win, paramsForExtraInfo);

	cookieNames.forEach((mappedCookieName, cookieName) => {
		const cookieValue = win.Cookies.get(cookieName);

		// We inject the cookie if it exists
		if (cookieValue) {
			createOrUpdateHiddenField(
				form,
				`_custom=${mappedCookieName.toUpperCase()}=1=${mappedCookieName}`,
				cookieValue
			);
		}
	});

	// First, inject configured params with their mappings
	paramNames.forEach((param) => {
		const paramValue = win.sessionStorage?.getItem(
			`extra-info-param-${param}`
		);

		// We inject the param if it exists
		if (paramValue) {
			createOrUpdateHiddenField(
				form,
				`_custom=${param.toUpperCase()}=1=${param}`,
				paramValue
			);
		}
	});

	// Then, always inject default ad params (even if custom mapping exists)
	// This ensures extra info always has the standard param names
	DEFAULT_AD_PARAMS.forEach((paramName) => {
		const paramValue = win.sessionStorage?.getItem(
			`extra-info-param-${paramName}`
		);

		// We inject the param if it exists
		if (paramValue) {
			createOrUpdateHiddenField(
				form,
				`_custom=${paramName.toUpperCase()}=1=${paramName}`,
				paramValue
			);
		}
	});
};
export default injectExtraInfo;
